module.exports = __webpack_public_path__ + "img/baleno-gls-prime-white.14203f96.png";